import React, { useState } from "react";
import styled from "styled-components";
import { FieldInput } from "../shared/OfferFormLayout";

const EntryWrap = styled.div`
	display: flex;
	flex-direction: column;
	gap: 1rem;
	min-width: min(28rem, 80vw);
`;

const InputRow = styled.div`
	display: flex;
	gap: 0.5rem;
	align-items: center;
`;

const IconButton = styled.span.attrs({
	className: "material-symbols-outlined",
})`
	cursor: pointer;
	color: #36395a;
	user-select: none;
	flex-shrink: 0;
	line-height: 1;
`;

const StatusText = styled.p`
	margin: 0;
	color: rgba(0, 0, 0, 0.55);
	font-size: 0.9rem;
`;

const IdEntryModal = ({ placeholder = "Enter ID", selectedIds = [], onAdd }) => {
	const [value, setValue] = useState("");
	const selectedSet = new Set(selectedIds);
	const trimmed = value.trim();
	const isDuplicate = Boolean(trimmed) && selectedSet.has(trimmed);

	function submit() {
		if (!trimmed || isDuplicate) return;
		onAdd?.(trimmed);
		setValue("");
	}

	return (
		<EntryWrap>
			<InputRow>
				<FieldInput
					value={value}
					onChange={(e) => setValue(e.target.value)}
					placeholder={placeholder}
					autoFocus
					onKeyDown={(e) => {
						if (e.key === "Enter") {
							e.preventDefault();
							submit();
						}
					}}
				/>
				<IconButton role="button" aria-label="Add ID" onClick={submit}>
					add
				</IconButton>
			</InputRow>
			{isDuplicate && <StatusText>This ID is already added</StatusText>}
		</EntryWrap>
	);
};

export default IdEntryModal;
